"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNotificationSchema = exports.UserNotificationTypeSchema = void 0;
const zod_1 = require("zod");
// ---------------------------------------------------------------------------
// UserNotification — in-app notification bell for platform-app users.
//
// Covers support replies/status changes, a support agent calling the user's
// phone, and general system messages. One row per notification; `sk` sorts
// newest-first with a zero-padded epoch-ms prefix so a query can page without
// a GSI. `expiresAt` is an epoch-seconds DynamoDB TTL attribute.
// ---------------------------------------------------------------------------
exports.UserNotificationTypeSchema = zod_1.z.enum([
    'support_reply',
    'support_status',
    'support_call',
    'system',
    'video_assignment',
]);
exports.UserNotificationSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    sk: zod_1.z.string(), // `${String(createdAt).padStart(15,'0')}#${id}`
    id: zod_1.z.string(), // 'ntf_<base36ts><6rand>'
    tenantId: zod_1.z.string().optional(),
    type: exports.UserNotificationTypeSchema,
    title: zod_1.z.string().max(200),
    body: zod_1.z.string().max(500).optional(),
    link: zod_1.z.string().max(300).optional(),
    issueId: zod_1.z.string().optional(),
    read: zod_1.z.boolean(),
    createdAt: zod_1.z.number(), // epoch ms
    expiresAt: zod_1.z.number(), // epoch-seconds TTL, createdAt + 90d
});
//# sourceMappingURL=user-notification.schema.js.map